import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export type LPCComplianceEnvironment = 'Prod' | 'Blackforest' | 'GccModerate' | 'GccHigh' | 'DoD' | 'Unknown';

/**
 * Config for people cards.
 */
export interface PeopleCardConfig {
    clientType: string;
    clientContextType: string;
    region: string;
    complianceEnvironment: LPCComplianceEnvironment;
}

@Injectable({
    providedIn: 'root'
})
export class PeopleCardConfigService {
    public readonly config: PeopleCardConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<PeopleCardConfig>('peopleCardConfig');
    }
}
